import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'order-list-result',
    templateUrl: './order-list-result.component.html',
    styleUrls: ['./order-list-result.component.scss'],
    standalone: false
})
export class OrderListPopup {
  errorReportData: any;

  constructor(
    public dialogRef: MatDialogRef<OrderListPopup>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.errorReportData = data.errorReportData;
  }

  downloadFile(): void {
    const blob = new Blob([this.errorReportData], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const now = new Date();
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob); 
    link.download = 'Order File Error Report ' + now.toLocaleDateString() + '.xlsx';
    link.click();
    window.URL.revokeObjectURL(link.href);
    link.remove();
    this.cancel();
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
